export const ModuloPermiso = {
    //1.- Página principal
    PaginaPrincipal: {
        Index: 1
    }
    //2.- Empresa
    , Empresa: {
        Modificar: 2
        , Index: 3
    }
    //3.- Sucursales
    , Sucursales: {
        Nuevo: 4
        , Modificar: 5
        , Eliminar: 6
        , Obtener: 7
        , ObtenerTodos: 8
        , Index: 9
    }
    //4.- Usuarios
    , Usuarios: {
        Nuevo: 10
        , Modificar: 11
        , Eliminar: 12
        , Obtener: 13
        , ObtenerTodos: 14
        , Index: 15
        , Desbloquear: 16
    }
    //5.- Asignación de usuario
    , AsignacionDeUsuario: {
        Nuevo: 17
        , Modificar: 18
        , Eliminar: 19
        , Obtener: 20
        , ObtenerTodos: 21
        , Index: 22
    }
    //6.- Usuarios por sucursal
    , UsuariosPorSucursal: {
        Nuevo: 23
        , Modificar: 24
        , Eliminar: 25
        , Obtener: 26
        , ObtenerTodos: 27
        , Index: 28
    }
    //7.- Roles por usuario
    , RolesPorUsuario: {
        Nuevo: 29
        , Modificar: 30
        , Eliminar: 31
        , Obtener: 32
        , ObtenerTodos: 33
        , Index: 34
    }
    //8.- Roles
    , Roles: {
        Nuevo: 35
        , Modificar: 36
        , Eliminar: 37
        , Obtener: 38
        , ObtenerTodos: 39
        , Index: 40
    }
    //9.- Tipos de usuario
    , TiposDeUsuario: {
        Nuevo: 41
        , Modificar: 42
        , Eliminar: 43
        , Obtener: 44
        , ObtenerTodos: 45
        , Index: 46
    }
    //10.- Roles po tipo de usuario
    , RolesPorTipoDeUsuario: {
        Nuevo: 47
        , Modificar: 48
        , Eliminar: 49
        , Obtener: 50
        , ObtenerTodos: 51
        , Index: 52
    }
    //11.- Congresistas
    , Congresistas: {
        Nuevo: 53
        , Modificar: 54
        , Eliminar: 55
        , Obtener: 56
        , ObtenerTodos: 57
        , Index: 58
    }
    //12.- Comision
    , Comision: {
        Nuevo: 59
        , Modificar: 60
        , Eliminar: 61
        , Obtener: 62
        , ObtenerTodos: 63
        , Index: 64
    }
    //13.- Proyecto de ley
    , ProyectoDeLey: {
        Nuevo: 65
        , Modificar: 66
        , Eliminar: 67
        , Obtener: 68
        , ObtenerTodos: 69
        , Index: 70
    }
    //14.- Blog nuestra democracia
    , BlogNuestraDemocracia: {
        Nuevo: 71
        , Modificar: 72
        , Eliminar: 73
        , Obtener: 74
        , ObtenerTodos: 75
        , Index: 76
    }
    //15.- Congreso visible
    , CongresoVisible: {
        Nuevo: 77
        , Modificar: 78
        , Eliminar: 79
        , Obtener: 80
        , ObtenerTodos: 81
        , Index: 82
        //Congreso Visible Equipo
        ,IndexEquipo:322
        ,ObtenerTodosEquipo:323
        ,NuevoEquipo:324
        ,ObtenerEquipo:325
        ,ModificarEquipo:326
        ,EliminarEquipo:327
        //Congreso Visible Integrante Equipo
        ,IndexIntegranteEquipo:328
        ,ObtenerTodosIntegranteEquipo:329
        ,NuevoIntegranteEquipo:330
        ,ObtenerIntegranteEquipo:331
        ,ModificarIntegranteEquipo:332
        ,EliminarIntegranteEquipo:333
        //Congreso Visible Aliados
        ,IndexAliado:334
        ,ObtenerTodosAliados:335
        ,NuevoAliado:336
        ,ObtenerAliado:337
        ,ModificarAliado:338
        ,EliminarAliado:339
    }
    //16.- Control politico
    , ControlPolitico: {
        Nuevo: 83
        , Modificar: 84
        , Eliminar: 85
        , Obtener: 86
        , ObtenerTodos: 87
        , Index: 88
        ,IndexProposiciones: 299
        ,AgregarProposiciones: 300
        ,ObtenerProposiciones: 301
        ,ModificarProposiciones: 302
        ,EliminarProposiciones: 303
        ,IndexCitantes: 304
        ,AgregarCitantes: 305
        ,EliminarCitantes: 306
        ,IndexCitados: 307
        ,AgregarCitados: 308
        ,ObtenerCitados: 309
        ,ModificarCitados: 310
        ,EliminarCitados: 311
        ,IndexRespuestas: 312
        ,AgregarRespuestas: 313
        ,ObtenerRespuestas: 314
        ,ModificarRespuestas: 315
        ,EliminarRespuestas: 316
        ,IndexDocumentos: 317
        ,AgregarDocumentos: 318
        ,ObtenerDocumentos: 319
        ,ModificarDocumentos: 320
        ,EliminarDocumentos: 321
    }
    //17.- Agenda legislativa
    , AgendaLegislativa: {
        Nuevo: 89
        , Modificar: 90
        , Eliminar: 91
        , Obtener: 92
        , ObtenerTodos: 93
        , Index: 94
        , NuevaActividad:322
        , ModificarActividad:323
        , EliminarActividad:324
        , ObtenerActividad:325
        , IndexActividad:326
    }
    //18.- Secretario
    , Secretario: {
        Nuevo: 95
        , Modificar: 96
        , Eliminar: 97
        , Obtener: 98
        , ObtenerTodos: 99
        , Index: 100
    }
    //19.- Información del sitio
    , InformacionSitio: {
        Nuevo: 101
        , Modificar: 102
        , Eliminar: 103
        , Obtener: 104
        , ObtenerTodos: 105
        , Index: 106
    }
    //20.- Informes PNUD
    , InformesPnud: {
        Nuevo: 107
        , Modificar: 108
        , Eliminar: 109
        , Obtener: 110
        , ObtenerTodos: 111
        , Index: 112
    }
    //21.- Balance cuatrienio
    , BalanceCuatrienio: {
        Nuevo: 113
        , Modificar: 114
        , Eliminar: 115
        , Obtener: 116
        , ObtenerTodos: 117
        , Index: 118
    }
    //22.- Opinión
    , Opinion: {
        Nuevo: 119
        , Modificar: 120
        , Eliminar: 121
        , Obtener: 122
        , ObtenerTodos: 123
        , Index: 124
    }
    //23.- Opinión de congresista
    , OpinionCongresista: {
        Nuevo: 125
        , Modificar: 126
        , Eliminar: 127
        , Obtener: 128
        , ObtenerTodos: 129
        , Index: 130
    }
    //24.- Podcast
    , Podcast: {
        Nuevo: 131
        , Modificar: 132
        , Eliminar: 133
        , Obtener: 134
        , ObtenerTodos: 135
        , Index: 136
    }
    //25.- Multimedia
    , Multimedia: {
        Nuevo: 137
        , Modificar: 138
        , Eliminar: 139
        , Obtener: 140
        , ObtenerTodos: 141
        , Index: 142
    }
    //26.- Partidos
    , Partidos: {
        Nuevo: 143
        , Modificar: 144
        , Eliminar: 145
        , Obtener: 146
        , ObtenerTodos: 147
        , Index: 148
    }
    //27.- Votaciones
    , Votaciones: {
        Nuevo: 149
        , Modificar: 150
        , Eliminar: 151
        , Obtener: 152
        , ObtenerTodos: 153
        , Index: 154
    }
    //28.- Elecciones
    , Elecciones: {
        Nuevo: 155
        , Modificar: 156
        , Eliminar: 157
        , Obtener: 158
        , ObtenerTodos: 159
        , Index: 160
    }
    //29.- DatosContacto
    , DatosContacto: {
        Nuevo: 161
        , Modificar: 162
        , Eliminar: 163
        , Obtener: 164
        , ObtenerTodos: 165
        , Index: 166
    }
    //30.- Cuatrienio
    , Cuatrienio: {
        Nuevo: 167
        , Modificar: 168
        , Eliminar: 169
        , Obtener: 170
        , ObtenerTodos: 171
        , Index: 172
    }
    //31.- Departamento
    , Departamento: {
        Nuevo: 173
        , Modificar: 174
        , Eliminar: 175
        , Obtener: 176
        , ObtenerTodos: 177
        , Index: 178
    }
    //32.- Geografía
    , Geografia: {
        Nuevo: 179
        , Modificar: 180
        , Eliminar: 181
        , Obtener: 182
        , ObtenerTodos: 183
        , Index: 184
    }
    //33.- Genero
    , Genero: {
        Nuevo: 185
        , Modificar: 186
        , Eliminar: 187
        , Obtener: 188
        , ObtenerTodos: 189
        , Index: 190
    }
    //34.- Profesión
    , GradoEstudio: {
        Nuevo: 191
        , Modificar: 192
        , Eliminar: 193
        , Obtener: 194
        , ObtenerTodos: 195
        , Index: 196
    }
    //35.- Grupo edad
    , GrupoEdad: {
        Nuevo: 197
        , Modificar: 198
        , Eliminar: 199
        , Obtener: 200
        , ObtenerTodos: 201
        , Index: 202
    }
    //36.- Circunscripción
    , Circunscripcion: {
        Nuevo: 203
        , Modificar: 204
        , Eliminar: 205
        , Obtener: 206
        , ObtenerTodos: 207
        , Index: 208
    }
    //37.- Cargo
    , Cargo: {
        Nuevo: 209
        , Modificar: 210
        , Eliminar: 211
        , Obtener: 212
        , ObtenerTodos: 213
        , Index: 214
    }
    //38.- Cargo integrante
    , CargoIntegrante: {
        Nuevo: 215
        , Modificar: 216
        , Eliminar: 217
        , Obtener: 218
        , ObtenerTodos: 219
        , Index: 220
    }
    //39.- Estado proyecto de ley
    , EstadoProyectoLey: {
        Nuevo: 221
        , Modificar: 222
        , Eliminar: 223
        , Obtener: 224
        , ObtenerTodos: 225
        , Index: 226
    }
    //40.- Iniciativa
    , Iniciativa: {
        Nuevo: 227
        , Modificar: 228
        , Eliminar: 229
        , Obtener: 230
        , ObtenerTodos: 231
        , Index: 232
    }
    //41.- Legislatura
    , Legislatura: {
        Nuevo: 233
        , Modificar: 234
        , Eliminar: 235
        , Obtener: 236
        , ObtenerTodos: 237
        , Index: 238
    }
    //42.- Tema proyecto ley
    , TemaProyectoLey: {
        Nuevo: 239
        , Modificar: 240
        , Eliminar: 241
        , Obtener: 242
        , ObtenerTodos: 243
        , Index: 244
    }
    //43.- Tema control
    , TemaControl: {
        Nuevo: 245
        , Modificar: 246
        , Eliminar: 247
        , Obtener: 248
        , ObtenerTodos: 249
        , Index: 250
    }
    //44.- Tipo publicacion proyecto ley
    , TipoPublicacionProyectoLey: {
        Nuevo: 251
        , Modificar: 252
        , Eliminar: 253
        , Obtener: 254
        , ObtenerTodos: 255
        , Index: 256
    }
    //45.- Tipo fecha proyecto ley
    , TipoFechaProyectoLey: {
        Nuevo: 257
        , Modificar: 258
        , Eliminar: 259
        , Obtener: 260
        , ObtenerTodos: 261
        , Index: 262
    }
    //46.- Estado control politico
    , EstadoControlPolitico: {
        Nuevo: 263
        , Modificar: 264
        , Eliminar: 265
        , Obtener: 266
        , ObtenerTodos: 267
        , Index: 268
    }
    //47.- Glosario legislativo
    , GlosarioLegislativo: {
        Nuevo: 269
        , Modificar: 270
        , Eliminar: 271
        , Obtener: 272
        , ObtenerTodos: 273
        , Index: 274
    }
    //48.- Tema blog nuestra democracia
    , TemaBlogNuestraDemocracia: {
        Nuevo: 275
        , Modificar: 276
        , Eliminar: 277
        , Obtener: 278
        , ObtenerTodos: 279
        , Index: 280
    }
    //49.- Tipo actividad agenda legislativa
    , TipoActividadAgendaLegislativa: {
        Nuevo: 281
        , Modificar: 282
        , Eliminar: 283
        , Obtener: 284
        , ObtenerTodos: 285
        , Index: 286
    }
    //50.- Corporación
    , Corporacion: {
        Nuevo: 287
        , Modificar: 288
        , Eliminar: 289
        , Obtener: 290
        , ObtenerTodos: 291
        , Index: 292
    }
    //51.- Citación
    , Citacion: {
        Nuevo: 293
        , Modificar: 294
        , Eliminar: 295
        , Obtener: 296
        , ObtenerTodos: 297
        , Index: 298
    }

    //52.- Persona
    , Persona: {
        Nuevo: 340
        , Modificar: 341
        , Eliminar: 342
        , Obtener: 343
        , ObtenerTodos: 344
        , Index: 345
    }
    //53.- Profesión
    , Profesion: {
        Nuevo: 346
        , Modificar: 347
        , Eliminar: 348
        , Obtener: 349
        , ObtenerTodos: 350
        , Index: 351
    }
    //54.- Región
    , Region: {
        Nuevo: 352
        , Modificar: 353
        , Eliminar: 354
        , Obtener: 355
        , ObtenerTodos: 356
        , Index: 357
    }
    //55.- Muncipio
    , Municipio: {
        Nuevo: 358
        , Modificar: 359
        , Eliminar: 360
        , Obtener: 361
        , ObtenerTodos: 362
        , Index: 363
    }
    //57.- Congresista conflicto de interés
    , CongresistaConflictoInteres: {
        Modificar: 370
        , Obtener: 371
        , Index: 372
    }
    //58.- Cf Órgano
    , CfOrgano: {
        Nuevo: 373
        , Modificar: 374
        , Eliminar: 375
        , Obtener: 376
        , ObtenerTodos: 377
        , Index: 378
    }
    //59.- Cf Calidad miembro
    , CfCalidadMiembro: {
        Nuevo: 379
        , Modificar: 380
        , Eliminar: 381
        , Obtener: 382
        , ObtenerTodos: 383
        , Index: 384
    }

    //60.- País
    , Pais: {
        Nuevo: 385
        , Modificar: 386
        , Eliminar: 387
        , Obtener: 388
        , ObtenerTodos: 389
        , Index: 390
    }

    //61.- Cf Parentesco
    , CfParentesco: {
        Nuevo: 391
        , Modificar: 392
        , Eliminar: 393
        , Obtener: 394
        , ObtenerTodos: 395
        , Index: 396
    }

    //62.- Cf Acreencia cpt
    , CfAcreenciaCpt: {
        Nuevo: 397
        , Modificar: 398
        , Eliminar: 399
        , Obtener: 400
        , ObtenerTodos: 401
        , Index: 402
    }

    //63.- Cf tipo bien
    , CfTipoBien: {
        Nuevo: 403
        , Modificar: 404
        , Eliminar: 405
        , Obtener: 406
        , ObtenerTodos: 407
        , Index: 408
    }

    //64.- CfDepartamento
    , CfDepartamento: {
        Nuevo: 409
        , Modificar: 410
        , Eliminar: 411
        , Obtener: 412
        , ObtenerTodos: 413
        , Index: 414
    }

    //65.- Cf tipo documento
    , CfTipoDocumento: {
        Nuevo: 415
        , Modificar: 416
        , Eliminar: 417
        , Obtener: 418
        , ObtenerTodos: 419
        , Index: 420
    }
}
